
import { Routes } from '@angular/router';
import { PreloginRoutes } from '@core/prelogin/prelogin.routes';

import {
    SalesClaimRoutes, PointSummaryRoutes, CouponClaimRoutes, InvoiceClaimRoutes, LegalPageRoutes, QuizRoutes, DashboardRoutes,
    GoalQuestRoutes, GameRoutes, MyPerformanceRoutes, MyAwardsRoutes, EmbeddedReportRoutes, MessagePageRoutes, QuestionPageRoutes,
    ErrorRoutes, ContentPageRoutes, LeagueRoutes, HubPageRoutes, AccountRoutes, TabViewRoutes, CommunicationRoutes, RegistrationApprovalRoutes, ContactUsPageRoutes
} from '@core/private';
import { MembershipTieringRoutes } from './private/membership-tiering/membership-tiering-routes';
import { MyThresholdAwardsRoutes } from './private/mythresholdawards/my-threshold-awards.routes';
import { NotificationCornerRoutes } from './private/notificationcorner';
import { CashRewardsRoute } from './private/cashrewards/cashrewards.routes';
import { CatalogueAccessRoutes } from './private/catalogueaccess/catalogueaccess.routes';
import { OrderManagementRoutes } from './private/ordermanagement';
import { OfflineOrderManagementRoutes } from './private/offlinetransactions';

export const CoreRoutes: Routes = [
    ...DashboardRoutes,
    ...PreloginRoutes,
    ...SalesClaimRoutes,
    ...PointSummaryRoutes,
    ...CouponClaimRoutes,
    ...OrderManagementRoutes,
    ...OfflineOrderManagementRoutes,
    ...InvoiceClaimRoutes,
    ...LegalPageRoutes,
    ...QuizRoutes,
    ...GoalQuestRoutes,
    ...GameRoutes,
    ...MyPerformanceRoutes,
    ...MyAwardsRoutes,
    ...EmbeddedReportRoutes,
    ...MessagePageRoutes,
    ...QuestionPageRoutes,
    ...ErrorRoutes,
    ...ContentPageRoutes,
    ...LeagueRoutes,
    ...HubPageRoutes,
    ...AccountRoutes,
    ...MyThresholdAwardsRoutes,
    ...MembershipTieringRoutes,
    ...NotificationCornerRoutes,
    ...TabViewRoutes,
    ...CommunicationRoutes,
    ...RegistrationApprovalRoutes,
    ...ContactUsPageRoutes,
    ...CashRewardsRoute,
    ...CatalogueAccessRoutes,
    {
        path: '**',
        redirectTo: ''
    }
];
